export default __webpack_public_path__ + "static/inspiration-wardrobe-369ea8e7355f861ef4d5412e0f4c313b.png";